export function setupUserCardLookup() {
    const userCardLookupForm = document.querySelector('[data-user-card-lookup]');
    const createUserFormModule = document.getElementById('createUserFormModule');
    let createUserForm;
    let userIsValid = false;
    let token;

    function checkUserValidity(e) {
        if (!userIsValid) {
            e.preventDefault();

            const validateEndpoint = '/api/companycard/validatetoken';

            fetch(validateEndpoint, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'post',
                body: JSON.stringify(token),
            })
                .then(response => {
                    switch (response.status) {
                        case 401:
                        case 400:
                            // Error

                            break;
                        case 200:
                            console.log('user is valid!');
                            userIsValid = true;

                            setTimeout(function() {
                                createUserForm.submit();
                            },10);

                            break;
                    }
                })
                .catch(error => {
                    // Errors
                });
        }
    }

    function checkCompanyInfo(e) {
        e.preventDefault();

        const endpoint = userCardLookupForm.getAttribute('data-endpoint');

        if (endpoint) {
            const formData = new FormData(userCardLookupForm);
            const messages = userCardLookupForm.querySelectorAll('.user-card-lookup__error-message');

            const object = {};

            formData.forEach(function(value, key) {
                object[key] = value;
            });

            const formJson = JSON.stringify(object);

            fetch(endpoint, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'post',
                body: formJson,
            })
                .then(response => {
                    switch (response.status) {
                        case 404:
                        case 403:
                        case 400:
                            const message = Array.from(messages).find(x => x.getAttribute('data-status') == response.status);
                            const otherMessages = Array.from(messages).filter(x => x != message);
                            otherMessages.forEach(message => {
                                message.classList.remove('user-card-lookup__error-message--show');
                            });

                            if (message) {
                                message.classList.add('user-card-lookup__error-message--show');
                            }

                            break;
                        case 200:
                            messages.forEach(message => {
                                message.classList.remove('user-card-lookup__error-message--show');
                            });

                            return response;
                    }
                })
                .then(response => response.json())
                .then(data => {
                    createUserFormModule.classList.remove('user-card-lookup--hidden');

                    setTimeout(function() {
                        createUserFormModule.scrollIntoView();
                    },10);

                    const cardNumber = data.CardNumber;
                    const company = data.Company;
                    token = data.Token;

                    createUserForm = createUserFormModule.querySelector('.user-card-lookup__form');
                    const cardNumberField = document.getElementById('CustomField.AccessUser_AccessUser_AccessCardNumber');
                    const externalIdField = document.getElementById('UserManagement_Form_ExternalId');
                    const companyField = document.getElementById('UserManagement_Form_Company');

                    if (createUserForm && cardNumberField && externalIdField && companyField) {
                        cardNumberField.value = cardNumber;
                        externalIdField.value = cardNumber;
                        companyField.value = company;

                        createUserForm.addEventListener('submit', checkUserValidity);
                    }
                })
                .catch(error => {
                    // Error...
                });
        }
    }

    if (userCardLookupForm && createUserFormModule) {
        const submitButton = userCardLookupForm.querySelector('button[type="submit"]');

        if (submitButton) {
            submitButton.addEventListener('click',checkCompanyInfo);
        }
    }
}
